import React, { useEffect, useState } from 'react';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Button, CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import AuthCheckComponent from '../../Layouts/Token';
import '../Documents/Documents.css';
import '../Documents/Documentslist.css';

const REVIEW_FORM_CACHE_KEY = 'review-form-list-cache';

const getCachedReviewForms = () => {
    try {
        const cachedValue = sessionStorage.getItem(REVIEW_FORM_CACHE_KEY);
        if (!cachedValue) return [];

        const parsedValue = JSON.parse(cachedValue);
        return Array.isArray(parsedValue) ? parsedValue : [];
    } catch (error) {
        console.error('Error reading cached review forms:', error);
        return [];
    }
};

const normalizeReviewForms = (response) => {
    const rawList = Array.isArray(response?.data)
        ? response.data
        : Array.isArray(response)
            ? response
            : Array.isArray(response?.forms)
                ? response.forms
                : [];

    return [...rawList].sort((a, b) => Number(b?.id || 0) - Number(a?.id || 0));
};

export default function Reviewformlist(props) {
    const classes = props;
    const [data, setData] = useState(() => getCachedReviewForms());
    const [loading, setLoading] = useState(() => getCachedReviewForms().length === 0);

    useEffect(() => {
        fetchReviewForms();
    }, []);

    const fetchReviewForms = async () => {
        const cachedForms = getCachedReviewForms();
        const hasExistingData = cachedForms.length > 0 || data.length > 0;

        if (!hasExistingData) {
            setLoading(true);
        }

        try {
            const response = await Authapi.Reviewformlist();
            const list = normalizeReviewForms(response);
            setData(list);
            sessionStorage.setItem(REVIEW_FORM_CACHE_KEY, JSON.stringify(list));
        } catch (error) {
            console.error('Error fetching review form data:', error);
            if (!hasExistingData) {
                setData([]);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        props.history.push('/review-form-add');
    };

    const handleEdit = (id) => {
        props.history.push(`/review-form-edit/${id}`);
    };

    const handleDelete = async (id) => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: ["Cancel", "Yes"]
        }).then(async (confirm) => {
            if (confirm) {
                try {
                    const response = await Authapi.Reviewformdelete(id);
                    if (response && response.status === true) {
                        swal("Success", "Form deleted successfully!", "success");
                        fetchReviewForms();
                    } else {
                        swal("Error", "Failed to delete form.", "error");
                    }
                } catch (error) {
                    console.error('Error deleting review form:', error);
                    swal("Error", "Failed to delete form.", "error");
                }
            }
        });
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                setAutUser={props.setAutUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Review Form"
                                    primaryPageLink="/review-form-list"
                                    isSecondaryPage={false}
                                    secondaryPageName=""
                                />
                            </CardContent>
                        </Card>

                        <Grid container className={classes.root} spacing={2} style={{ marginBottom: "75px" }}>
                            <Grid item xs={12}>
                                <Card className={`${classes.root} template-list-card`}>
                                    <Grid item xs={12}>
                                        <div className="template-list-header">
                                            <CardContent className="template-list-header-content">
                                                <Typography variant="h2" className="common-section-page-title" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0, marginBottom: "0" }}>
                                                    Review Form All
                                                </Typography>
                                            </CardContent>
                                            <div className="template-list-header-action" style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleAdd}
                                                    color="primary"
                                                    className="common-action-button common-add-button"
                                                    style={{ textTransform: 'capitalize' }}
                                                >
                                                    Add
                                                </Button>
                                            </div>
                                        </div>
                                    </Grid>

                                    <Grid container className={`${classes.root} template-list-grid`} spacing={3}>
                                        {loading ? (
                                            <Grid item xs={12} style={{ padding: "12px", minHeight: "150px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "24px" }}>
                                                <CircularProgress size={28} />
                                            </Grid>
                                        ) : Array.isArray(data) && data.length > 0 ? data.map((item) => (
                                            <Grid item xs={12} sm={6} md={4} key={item.id} className="template-grid-item">
                                                <Card className={`${classes.card} template-item-card`}>
                                                    <CardContent className="template-item-card-content">
                                                        <Typography variant="h5" component="div" className="template-item-title">
                                                            {item.form_name || '-'}
                                                        </Typography>

                                                        <Grid
                                                            container
                                                            className={`${classes.root} template-item-actions`}
                                                            spacing={0}
                                                            justifyContent="center"
                                                            alignItems="center"
                                                        >
                                                            <Grid item>
                                                                <Tooltip title="Edit">
                                                                    <IconButton
                                                                        variant="contained"
                                                                        color="primary"
                                                                        className="common-action-icon"
                                                                        onClick={() => handleEdit(item.id)}
                                                                    >
                                                                        <FontAwesomeIconComponent
                                                                            classes="fa fa-edit"
                                                                            colorName="primary"
                                                                            fontSize={"small"}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>

                                                            <Grid item>
                                                                <Tooltip title="Delete">
                                                                    <IconButton
                                                                        variant="contained"
                                                                        color="primary"
                                                                        className="common-action-icon"
                                                                        onClick={() => handleDelete(item.id)}
                                                                    >
                                                                        <FontAwesomeIconComponent
                                                                            classes="fa fa-trash"
                                                                            colorName="primary"
                                                                            fontSize={"small"}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        )) : (
                                            <Grid item xs={12} style={{ padding: "12px", minHeight: "150px", display: "flex", justifyContent: "center", alignItems: "flex-start", marginTop: "40px" }}>
                                                <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                                                    No review forms available
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                }
            />
            <Footer {...props} />
        </div>
    );
}
